
































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "shorturl/list";

  dispatchTypeDelete = "shorturl/delete";

  deleteConfirmContent = "确定删除该短网址吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "短网址", scopedSlots: { customRender: "urlshort" } },
    { title: "长网址", dataIndex: "urllong" },
    { title: "说明", dataIndex: "description" },
    { title: "时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
